var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.module === 'community' || _vm.module === 'studyRoom')?_c('top-bar',{attrs:{"type":_vm.module}}):_vm._e(),(_vm.module === 'community' || _vm.module === 'studyRoom')?_c('main',{staticClass:"main"},[_c('router-view')],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }